import type { FaireProductEntity } from "../../entity_types/product";

export const p_7jz72y2hjb: FaireProductEntity = {
  token: "p_7jz72y2hjb",
  type: "product",
  name: "Striped Belted Shirt Midi Dress",
  brandToken: "b_1v2htisz",
  brandName: "En Crème",
  imageUrl:
    "https://cdn.faire.com/fastly/608a070d565633277e25dd4d72c402febcdcae309634503e22f4fd3ebaf68418.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9f854aa4a7358fa33c3dbe46b5feb0d4fbbaa08c4c241fa27f97bc8f4464918.jpeg",
    "https://cdn.faire.com/fastly/70502a97aa4f4bebd71a0b5a2a906c06de0c75bfc6912b207477f50238971c4c.jpeg",
    "https://cdn.faire.com/fastly/724e601c6f64589933232ff67be5ffe1444b537d2b72cb4449bed7220c0d356b.jpeg",
    "https://cdn.faire.com/fastly/3e4dbfed374b2fc43739dd5d843033cc582b547132b77ea704941c759e64e040.jpeg",
    "https://cdn.faire.com/fastly/5d9073c91109a325a3e56edd71e544f48e15bf4531ccac5a9c576c5e13bb051a.jpeg",
    "https://cdn.faire.com/fastly/23c0fc88a6d3bc349a1aca5401bd7f4c2a9085adaa02bc3d4871d35705737648.jpeg",
    "https://cdn.faire.com/fastly/3f65a1869bb13df26cb5fe0d76da118fa8b7cc9ef0c9124ff525c3d53390d81d.jpeg",
    "https://cdn.faire.com/fastly/75f13e825373f32d863cbfb1460c5604cda6c11e34e47bbd78f3f779e3d4fb6a.jpeg",
    "https://cdn.faire.com/fastly/065956736f403901208d903d272068045a2978b799ae5b531295d57e01c0935f.jpeg",
    "https://cdn.faire.com/fastly/11e0ac6c0073e189dfb25af081e1e9b88574fbe4b4d9483da2fb6eda45e54bbd.jpeg",
    "https://cdn.faire.com/fastly/fd6cb37ee6a3b2d2e64ee5c28d3e72a11b6c000b446c8b0a9aac035d50a9094f.jpeg",
    "https://cdn.faire.com/fastly/623ede9d2e1fd87bcb9aae7a87032c3102127f996f56486295a77b7b1274fb9b.jpeg",
    "https://cdn.faire.com/fastly/66950857377109caf2910b7fa647e78a8e4b480b6af3c74ebc54e7778c59647f.jpeg",
  ],
  priceDollars: 27.95,
  description:
    "Striped Belted Shirt Midi Dress\nShell: 100% Rayon | Lining: 100% Cotton\nSize S(2) - M(2) - L(2)\nMade in India\n\n• Model is 5'8\" and is wearing a small.",
  tags: [],
  msrpDollars: 55.9,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:03.178Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
